import React, { useState } from "react";
import axios from "axios";

function Register() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const register = async () => {
    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/api/users/register`, {
        username,
        password,
      });
      alert("User registered successfully");
      setUsername("");
      setPassword("");
    } catch (err) {
      alert("Registration failed");
    }
  };

  return (
    <div className="mb-4">
      <input
        value={username}
        onChange={(e) => setUsername(e.target.value)}
        placeholder="New Username"
        className="border p-2 mr-2"
      />
      <input
        type="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        placeholder="New Password"
        className="border p-2 mr-2"
      />
      <button onClick={register} className="bg-purple-500 text-white px-4 py-2">
        Register
      </button>
    </div>
  );
}

export default Register;
